export default {
  operateOption: true,
  operateOptions: {
    width: 200
  },
  props: [
    {
      attr: 'activationCode',
      name: '激活码'
    },
    {
      attr: 'bindCount',
      name: '绑定设备数量',
      slot: 'bindCount'
    },
    {
      attr: 'orgName',
      name: '校区名称'
    },
    {
      attr: 'startTime',
      name: '激活日期',
      slot: 'startTime'
    },
    {
      attr: 'endTime',
      name: '失效日期',
      slot: 'endTime'
    },
    {
      attr: 'activationStatus',
      name: '激活码状态',
      slot: 'activationStatus'
    }
  ]
}
